import template from './timeField.html';
import controller from './timeField.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    field: '<',
    onUpdate: '&',
  }
};

export default component;
